import { AbstractMethodError, Rectangle } from '@awayjs/core';
import { ShaderRegisterCache } from '../../shaders/ShaderRegisterCache';
import { ContextGLProfile } from '../../base/ContextGLProfile';
import { AGALMiniAssembler } from '../../aglsl/assembler/AGALMiniAssembler';
import { ContextGLProgramType } from '../../base/ContextGLProgramType';
var TaskBase = /** @class */ (function () {
    function TaskBase(requireDepthRender) {
        if (requireDepthRender === void 0) { requireDepthRender = false; }
        this._vertexConstantData = new Float32Array([
            0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0
        ]);
        this.activateInternaly = false;
        this.sourceSamplerIndex = 0;
        this._program3DInvalid = true;
        this.inputRect = new Rectangle();
        this.destRect = new Rectangle();
        /**
         * Used for determine that this pass requrie clear target before render to it
         */
        this.needClear = false;
        this._requireDepthRender = requireDepthRender;
        this._registerCache = new ShaderRegisterCache(ContextGLProfile.BASELINE);
    }
    Object.defineProperty(TaskBase.prototype, "source", {
        get: function () {
            return this._source;
        },
        set: function (v) {
            this._source = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TaskBase.prototype, "target", {
        get: function () {
            return this._target;
        },
        set: function (value) {
            this._target = value;
        },
        enumerable: false,
        configurable: true
    });
    TaskBase.prototype.dispose = function () {
        if (this._program3D)
            this._program3D.dispose();
    };
    TaskBase.prototype.invalidateProgram = function () {
        this._program3DInvalid = true;
    };
    TaskBase.prototype.updateProgram = function (stage) {
        if (this._program3D)
            this._program3D.dispose();
        this._program3D = stage.context.createProgram();
        this._registerCache.reset();
        var vertexByteCode = (new AGALMiniAssembler()
            .assemble('part vertex 1\n' + this.getVertexCode() + 'endpart'))['vertex'].data;
        var fragmentByteCode = (new AGALMiniAssembler()
            .assemble('part fragment 1\n' + this.getFragmentCode() + 'endpart'))['fragment'].data;
        this._program3D.name = this.constructor.name;
        this._program3D.upload(vertexByteCode, fragmentByteCode);
        this._program3DInvalid = false;
    };
    TaskBase.prototype.getVertexCode = function () {
        var temp1 = this._registerCache.getFreeVertexVectorTemp();
        var posRect = this._registerCache.getFreeVertexConstant();
        var position = this._registerCache.getFreeVertexAttribute();
        this._positionIndex = position.index;
        var uvRect = this._registerCache.getFreeVertexConstant();
        this._uvVarying = this._registerCache.getFreeVarying();
        var code = 'mul ' + temp1 + '.xy, ' + position + ', ' + posRect + '.zw\n' +
            'add ' + temp1 + '.xy, ' + temp1 + ', ' + posRect + '.xy\n' +
            'mov ' + temp1 + '.w, ' + position + '.w\n' +
            'mov op, ' + temp1 + '\n' +
            'mul ' + temp1 + '.xy, ' + position + ', ' + uvRect + '.zw\n' +
            'add ' + this._uvVarying + ', ' + temp1 + ', ' + uvRect + '.xy\n';
        return code;
    };
    TaskBase.prototype.getFragmentCode = function () {
        throw new AbstractMethodError();
    };
    TaskBase.prototype.getProgram = function (stage) {
        if (this._program3DInvalid)
            this.updateProgram(stage);
        return this._program3D;
    };
    TaskBase.prototype.computeVertexData = function () {
        var data = this._vertexConstantData;
        var dest = this.destRect;
        var input = this.inputRect;
        var target = this._target;
        var source = this._source;
        if (input.width * input.height === 0) {
            input.width = this._source.width;
            input.height = this._source.height;
        }
        if (dest.width * dest.height === 0) {
            dest.width = input.width;
            dest.height = input.height;
        }
        // pos = scale * pos + offset
        // pos in viewport MUST be -1 - 0, for this we multiple at 2 and decrease 1
        // pos offset (-1, 1)
        data[0] = 2. * dest.x / target.width - 1;
        data[1] = 2. * dest.y / target.height - 1;
        // pos scale
        data[2] = 2. * dest.width / target.width;
        data[3] = 2. * dest.height / target.height;
        // uv already from 0,1, not require remap it
        // uv offset
        data[4] = input.x / source.width;
        data[5] = input.y / source.height;
        // uv scale
        data[6] = input.width / source.width;
        data[7] = input.height / source.height;
    };
    TaskBase.prototype.preActivate = function (_stage) { };
    TaskBase.prototype.activate = function (stage, _projection, _depthTexture) {
        this.computeVertexData();
        var context = stage.context;
        context.setProgramConstantsFromArray(ContextGLProgramType.VERTEX, this._vertexConstantData);
    };
    TaskBase.prototype.deactivate = function (stage) {
    };
    Object.defineProperty(TaskBase.prototype, "requireDepthRender", {
        get: function () {
            return this._requireDepthRender;
        },
        enumerable: false,
        configurable: true
    });
    return TaskBase;
}());
export { TaskBase };
